module.exports = __webpack_public_path__ + "img/x1.31de198b.png";